<template>
    <div class="app">
          <div class="app-header dark">
              <div class="header-left">
                <div class="header-logo">
                  <div class="logo-icon">
                     <i></i>
                  </div>
                  <h3 class="logo-name">AI管理系统V2</h3>
                </div>
                <div class="header-app-list">
                  <el-select v-model="curAppId" placeholder="请选择" @change="changeValue($event)">
                      <el-option
                        v-for="item in appList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.id">
                        <span style="float: left">{{ item.name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.id }}</span>
                      </el-option>
                    </el-select>
                </div>
              </div>
              <RightMenu />
          </div>
        <div class="app-aside" v-if="secondMenus && secondMenus.length > 0">
            <el-menu :default-active="secondMenuCur" class="app-menu" background-color="#00000000">
              <SubMenu :subMenuList="secondMenus"  mode="vertical"/>
            </el-menu>
            <!--
            <div class="aside-bottom">
               <div class="bottom-item" @click="goHome">所有应用</div>
            </div>
            -->
        </div>
      
        <div class="app-content">
            <router-view />
        </div>
    </div>
</template>
<script>
  import api from '@/utils/api';
  import SubMenu from '@/components/SubMenu'
  import RightMenu from '@/components/RightMenu'
  import {getUserInfo,deleteKey} from '@/utils/store';
  export default {
    components: {
      SubMenu,RightMenu
    },
    data() {
      return {
        headerMenus:[],
        secondMenus:[],
        secondMenuCur:'',
        headerMenuCur:'',
        headerTitle:'',
        userInfo:[],
        menuList:[],
        appId:0,
        curAppId:0,
        appList:[]
      };
    },
    mounted(){
        this.init()
        this.userInfo = getUserInfo()
    },
    watch: {
    '$route' (to, from) {
      console.log(to); 
      this.initMenu()
    },
    'headerMenuCur'(val){
       console.log(val); 
       if(val != this.headerMenuCur && val != this.$route.path){
          this.$router.push({path:val})
       }
    }
  },
    methods: {
      init(){
        //console.log("init"); 
        this.appId = parseInt(this.$route.params.appId);
        let options =  this.$router.options.routes[0];
        this.headerMenus = options.children;
        this.initMenu();
        this.initHeader();
      }, 
      initMenu(){
        let curPath = this.$route.matched;
        this.appId = parseInt(this.$route.params.appId);
        //this.curAppId = this.appId;
        //this.headerMenus = this.menuList;
        //console.log(this.appId)
           console.log(curPath)
        let len = curPath.length;
     console.log(len)
        if(this.appId >0){
          let options =  this.$router.options.routes[1];
          //console.log(this.$route.path);
          //console.log(options); 
          
          if(len > 2){
              this.secondMenuCur = curPath[2].path;
              //console.log(this.secondMenuCur)
          }
          this.secondMenus = options.children;
        }else{
          
          if(len > 1){
              this.headerMenuCur = curPath[1].path;
              //console.log(this.headerMenuCur)
          }
          this.headerMenus.forEach(element => {
            if(this.$route.path.indexOf(element.path) > -1){  
              if(element.children){
                this.secondMenus = element.children
                //this.secondMenuCur = this.$route.path
              }else{
                this.secondMenus = [];
              }
              //this.headerMenuCur = element.path
              this.headerTitle = element.title
            }
          })
        }
      },
      initHeader(){
            this.curAppId = this.appId
            console.log(typeof this.curAppId)
            api.get("/apps",{limit:1000}).then(res => {
              this.appList = res.list
            });
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClick(path){
        //console.log(path);  
        if(path != this.$route.path){
          path = path.replace(":appId",this.appId);
          this.$router.push({path:path})
       }
      },
      changeValue(value){
        console.log(value)
        console.log(this.appId)
        if(this.appId != value){
          let  path = this.$route.path
          path = path.replace(this.appId,value);
           this.$router.push({path:path})
           location.reload(); // 立即刷新页面
        }
      },
      goHome(){
        this.$router.push({path:"/appList"})
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/AppLayout.vue